import React, { useState } from "react";
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import AnimatedTitle from "../../../components/AnimatedTitle/AnimatedTitle";
import useUserStore from "../../../store/useUserStore";

const accordionData = [
  {
    question: "Чому ви маєте обрати саме нас?",
    answer: `Ми розуміємо, що вам потрібен не просто юрист, а особа, яка розуміє специфіку вашої діяльності: ми зможемо донести вашому працівнику, чому в НДА є неконкуренція і штраф; ми пояснимо вашому клієнту, чому гарантійний строк не працює в межах ІТ діяльності. Ми розуміємо, що ви робите, і це є ключовим для успішної співпраці.`,
  },
  {
    question: "Які послуги ви надаєте?",
    answer: `Ми надаємо повний спектр юридичних послуг для ІТ-бізнесу — від базової підготовки контрактів і захисту інтелектуальної власності до супроводу в міжнародних регуляторних питаннях. Ми працюємо як на проєктній основі (ad hoc), так і у форматі постійної правової підтримки. Наш підхід завжди гнучкий: ми разом з вами визначимо оптимальний формат співпраці — залежно від вашого навантаження, структури бізнесу та планів розвитку.`,
  },
  {
    question: "У яких країнах ми працюємо?",
    answer: `Ми працюємо з клієнтами по всьому світу. Маємо значний досвід юридичного супроводу бізнесу в країнах ЄС, США (включаючи окремі штати), Великобританії, Ізраїлі, Канаді, Сингапурі та Україні. Під кожен запит ми підбираємо рішення відповідно до локального законодавства та міжнародної практики.`,
  },
  {
    question: "З якими компаніями ми працюємо?",
    answer: `Ми працюємо як із стартапами, так і з великими компаніями, які вже мають сталу структуру та команду. Нам приємно супроводжувати клієнтів "від ідеї до скейлу", проте ми з однаковою залученістю долучаємось до роботи й на пізніших етапах розвитку компанії — коли йдеться про реструктуризацію, вихід на нові ринки або залучення інвестицій.`,
  },
  {
    question: "Як швидко ми реагуємо?",
    answer: `Ми цінуємо ваш час і розуміємо темп ІТ-бізнесу. Від самого початку співпраці ми узгоджуємо зручні для вас години комунікації і SLA — з урахуванням різниці в часі та терміновості запитів. Ми автоматизували типові процеси, щоб пришвидшити роботу, але завжди гарантуємо персоналізований підхід і швидкий фідбек на важливі питання.`,
  },
];

export default function QuestionsBlock({ scrollToRef }) {
  const windowInnerWidth = useUserStore((state) => state.windowInnerWidth);
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panelIndex) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panelIndex : null);
  };

  return (
    <Box
      ref={scrollToRef}
      sx={{
        width: "100%",
        padding: windowInnerWidth < 960 ? "0 20px" : "0 80px",
        display: "flex",
        justifyContent: "center",
        mt: "213px",
        "@media (min-width: 640px)": {
          mt: "288px",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1280px",
        }}
      >
        <AnimatedTitle text="Часті запитання" />
        <Box mt={4}>
          {accordionData.map((item, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={handleChange(index)}
              disableGutters
              elevation={0}
              square
              sx={{
                borderBottom: "1px solid #CBD3E1",
                backgroundColor: "transparent",
              }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === index ? (
                    <RemoveIcon
                      sx={{ fontSize: { xs: 28, md: 56 }, color: "#0B193E" }}
                    />
                  ) : (
                    <AddIcon
                      sx={{ fontSize: { xs: 28, md: 56 }, color: "#0B193E" }}
                    />
                  )
                }
                sx={{ py: 2 }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "20px",
                    color: "#0B193E",
                    textTransform: "uppercase",
                    "@media (min-width: 640px)": {
                      fontSize: "36px",
                    },
                  }}
                >
                  {item.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ py: 2 }}>
                <Typography sx={{ color: "#0B193E" }}>{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
